<template>
  <el-input
    :value="value"
    :type="visible ? 'text' : 'password'"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    @input="$emit('input', $event)"
  >
    <span slot="suffix" class="pwd-suffix" :title="visible ? $t('common.hide') : $t('common.show')">
      <!-- Checkbox+CSS switch to match the requested "eye blink" style. -->
      <label class="container">
        <input type="checkbox" v-model="visible" />
        <svg class="eye" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 5c5.5 0 9.9 4.3 11 7-1.1 2.7-5.5 7-11 7S2.1 14.7 1 12c1.1-2.7 5.5-7 11-7zm0 2C7.7 7 4.1 10.2 3.1 12c1 1.8 4.6 5 8.9 5s7.9-3.2 8.9-5c-1-1.8-4.6-5-8.9-5zm0 2.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6z"
          />
        </svg>
        <svg class="eye-slash" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M2 4.3 3.4 3l17.6 17.6-1.4 1.4-3-3c-1.4.7-3 1-4.6 1-5.5 0-9.9-4.3-11-7 .7-1.7 2.5-4.1 5.2-5.7L2 4.3zm5.6 5.6c-1.9 1-3.4 2.7-4.1 4.1 1 1.8 4.6 5 8.5 5 1 0 1.9-.2 2.8-.5l-1.6-1.6c-.4.1-.8.2-1.2.2a2.8 2.8 0 0 1-2.8-2.8c0-.4.1-.8.2-1.2L7.6 9.9zM12 7c1.6 0 3.1.3 4.5 1l-1.7 1.7a2.8 2.8 0 0 0-3.7-3.7L9.4 4.3C10.2 4.1 11.1 4 12 4c5.5 0 9.9 4.3 11 7-.5 1.3-1.7 3-3.4 4.4l-1.4-1.4c1.2-1.1 2.1-2.3 2.5-3-1-1.8-4.6-5-8.3-5-.6 0-1.2.1-1.8.2L9.1 5C10 4.7 11 4.5 12 4.5V7z"
          />
        </svg>
      </label>
    </span>
  </el-input>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    autocomplete: { type: String, default: 'current-password' }
  },
  data() {
    return { visible: false };
  }
};
</script>

<style scoped>
/* Ensure the suffix area is clickable and aligned. */
.pwd-suffix {
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0 8px;
}

/*------ Settings ------*/
.container {
  --color: #a5a5b0;
  --size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: var(--size);
  user-select: none;
  color: var(--color);
  fill: var(--color);
  height: 100%;
  width: 22px;
}

.container svg {
  width: 1em;
  height: 1em;
}

.container .eye {
  position: absolute;
  animation: keyframes-fill 0.5s;
}

.container .eye-slash {
  position: absolute;
  animation: keyframes-fill 0.5s;
  display: none;
}

/* ------ On check event ------ */
.container input:checked ~ .eye {
  display: none;
}

.container input:checked ~ .eye-slash {
  display: block;
}

/* ------ Hide the default checkbox ------ */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* ------ Animation ------ */
@keyframes keyframes-fill {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    transform: scale(1.2);
  }
}
</style>
